import types from './mutation-types';

export default {
  [types.UPDATE_MENU](state, menu) {
    state.menu = menu;
  },
  [types.UPDATE_TITLE](state, title) {
    state.title = title;
  },
  [types.UPDATE_IMAGE](state, image) {
    state.image = image;
  },
  [types.UPDATE_HAS_VALID_LICENSE](state, hasValidLicense) {
    state.hasValidLicense = hasValidLicense;
  },
  [types.DESTROY_MENU](state) {
    state.menu = {};
  },
  [types.DESTROY_TITLE](state) {
    state.title = '';
  },
  [types.DESTROY_IMAGE](state) {
    state.image = null;
  },
  [types.DESTROY_HAS_VALID_LICENSE](state) {
    state.hasValidLicense = false;
  },
};
